import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Button, FormGroup, Label, Input, Alert, Modal,
    ModalHeader, ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import { API } from 'aws-amplify';
import '../estilos.css';
import {
    listRecibaSerialess
} from '../../graphql/queries';
import * as IoIcons from 'react-icons/io';
import Pagination from "react-js-pagination";
import Moment, { updateLocale } from 'moment';
import { useReactToPrint } from 'react-to-print';
import { CSVLink, CSVDownload } from "react-csv";
import { GetRecibaSeriales } from '../queries/Queries';



function RPProduccion() {
    //Declaración de variables                
    const [recibaSeriales, setRecibaSeriales] = useState([]);
    const [recibaSinFiltro, setRecibaSinFiltro] = useState([]);
    const [recibaIMP, setRecibaIMP] = useState([]);
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const pRProducciones = window.$ProduccionReporteSema ? window.$ProduccionReporteSema : false;
    const [cargando, setCargando] = useState(false);
    const [aVisible, setAVisible] = useState(false);
    const [sumProduccionp, setSumProduccionp] = useState("");
    const [sumICiclos, setSumICiclos] = useState("");
    //const [dia, setDia] = useState("");
    const [fPDisabled, setFPDisabled] = useState(true);
    const onDismiss = () => setAVisible(false);
    const [paginasP, setPaginasP] = useState([]);
    Moment.locale('en');
    var now = new Date();
    var now2 = new Date();

    const dia = new Date().getDay();
    now2.setDate(now2.getDate() - dia);
    now.setDate(now.getDate() + (6 - dia));

    const [rfechaini, setRfechaini] = useState(Moment(now2).format("YYYY-MM-DD"));
    const [rfechafin, setRfechafin] = useState(Moment(now).format("YYYY-MM-DD"));

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    //Método useEffect
    useEffect(() => {
        fetchReciba(rfechaini, rfechafin);
    }, []);
    //Función que sirve para obtener los datos de una búsqueda.
    async function busquedaReciba(recibasinfiltro) {
        //Variables donde se agrupan los datos para mostrarlos e imprimirlos
        var recibaSerialesANP = [];
        //Variable donde se guardan los datos para descargarlos.
        var recibaSerialesIMP = [];
        //Se obtienen los datos ordenados por número de parte
        var recibaSerialesSOANP = await recibasinfiltro.sort((a, b) =>
            a.numerodeParte < b.numerodeParte ? 1 : a.numerodeParte > b.numerodeParte ? -1 : 0);

        //Variables auxiliares para sumar cantidades.        
        var cantidadPlaneada = parseFloat(recibaSerialesSOANP[0].cantidadPlaneada ? recibaSerialesSOANP[0].cantidadPlaneada : 0);
        var sumCandidadR = parseFloat(recibaSerialesSOANP[0].cantidadRecibida ? recibaSerialesSOANP[0].cantidadRecibida : 0);
        var piezasCarga = parseFloat(recibaSerialesSOANP[0].piezasenCarga ? recibaSerialesSOANP[0].piezasenCarga : 0);
        var piezasPintadas = parseInt(recibaSerialesSOANP[0].piezasPintadas ? recibaSerialesSOANP[0].piezasPintadas : 0);
        var piezasRecuperacion = parseFloat(recibaSerialesSOANP[0].piezasTRecuperacion ? recibaSerialesSOANP[0].piezasTRecuperacion : 0);
        var piezasInspeccionadas = parseFloat((recibaSerialesSOANP[0].piezasInspeccion ? recibaSerialesSOANP[0].piezasInspeccion : 0) +
            (recibaSerialesSOANP[0].piezasIRecuperacion ? recibaSerialesSOANP[0].piezasIRecuperacion : 0));
        var piezasAEmbarcar = parseFloat(recibaSerialesSOANP[0].piezasAEmbarcar ? recibaSerialesSOANP[0].piezasAEmbarcar : 0);
        var piezasAEmbarcadas = parseInt(recibaSerialesSOANP[0].piezasEmbarcadas ? recibaSerialesSOANP[0].piezasEmbarcadas : 0);
        var piezasenAlmacen = parseFloat(recibaSerialesSOANP[0].piezasenAlmacen ? recibaSerialesSOANP[0].piezasenAlmacen : 0);

        //Se suman todos los datos, como corresponde.
        await Promise.all(recibaSerialesSOANP.map(async (recibaseriales, j) => {
            //Si no se ha llegado al final del array
            if (recibaSerialesSOANP.length > j + 1) {
                //Si el número de parte del registro actual es igual al siguiente, es del mismo cliente y tiene la misma descripción
                if (recibaseriales.numerodeParte === recibaSerialesSOANP[j + 1].numerodeParte && recibaseriales.cliente === recibaSerialesSOANP[j + 1].cliente &&
                    recibaseriales.descripcion === recibaSerialesSOANP[j + 1].descripcion) {

                    //Se suman los datos                    
                    cantidadPlaneada = cantidadPlaneada + parseFloat(recibaSerialesSOANP[j + 1].cantidadPlaneada ? recibaSerialesSOANP[j + 1].cantidadPlaneada : 0);
                    sumCandidadR = sumCandidadR + parseFloat(recibaSerialesSOANP[j + 1].cantidadRecibida ? recibaSerialesSOANP[j + 1].cantidadRecibida : 0);
                    piezasCarga = piezasCarga + parseFloat(recibaSerialesSOANP[j + 1].piezasenCarga ? recibaSerialesSOANP[j + 1].piezasenCarga : 0);
                    piezasPintadas = piezasPintadas + parseInt(recibaSerialesSOANP[j + 1].piezasPintadas ? recibaSerialesSOANP[j + 1].piezasPintadas : 0);
                    piezasRecuperacion = piezasRecuperacion + parseFloat(recibaSerialesSOANP[j + 1].piezasTRecuperacion ? recibaSerialesSOANP[j + 1].piezasTRecuperacion : 0);
                    piezasInspeccionadas = piezasInspeccionadas + parseFloat((recibaSerialesSOANP[j + 1].piezasInspeccion ? recibaSerialesSOANP[j + 1].piezasInspeccion : 0) +
                        (recibaSerialesSOANP[j + 1].piezasIRecuperacion ? recibaSerialesSOANP[j + 1].piezasIRecuperacion : 0));
                    piezasAEmbarcar = piezasAEmbarcar + parseFloat(recibaSerialesSOANP[j + 1].piezasAEmbarcar ? recibaSerialesSOANP[j + 1].piezasAEmbarcar : 0);
                    piezasAEmbarcadas = piezasAEmbarcadas + parseFloat(recibaSerialesSOANP[j + 1].piezasEmbarcadas ? recibaSerialesSOANP[j + 1].piezasEmbarcadas : 0);
                    piezasenAlmacen = piezasenAlmacen + parseFloat(recibaSerialesSOANP[j + 1].piezasenAlmacen ? recibaSerialesSOANP[j + 1].piezasenAlmacen : 0);


                } else {
                    recibaSerialesANP.push({
                        ...recibaseriales, cantidadRecibida: sumCandidadR, piezasenCarga: piezasCarga,
                        piezasPintadas: piezasPintadas, cantidadPlaneada: cantidadPlaneada, piezasTRecuperacion: piezasRecuperacion,
                        piezasInspeccion: piezasInspeccionadas, piezasAEmbarcar: piezasAEmbarcar, piezasEmbarcadas: piezasAEmbarcadas,
                        piezasenAlmacen: piezasenAlmacen
                    });
                    //Array para imprimir
                    recibaSerialesIMP.push({
                        Cliente: recibaseriales.cliente, ["Número de parte"]: recibaseriales.numerodeParte, Descripción: recibaseriales.descripcion,
                        ["Cantidad recibida"]: sumCandidadR, ["Piezas cargadas"]: piezasCarga ? piezasCarga : 0, ["Piezas pintadas"]: piezasPintadas ? piezasPintadas : 0,
                        ["Piezas en recuperación"]: piezasRecuperacion ? piezasRecuperacion : 0,
                        ["Piezas inspeccionadas"]: piezasInspeccionadas, ["Piezas a embarcar"]: piezasAEmbarcar ? piezasAEmbarcar : 0, ["Piezas embarcadas"]: piezasAEmbarcadas ? piezasAEmbarcadas : 0,
                        ["Piezas en almacen"]: piezasenAlmacen ? piezasenAlmacen : 0
                    });

                    cantidadPlaneada = parseFloat(recibaSerialesSOANP[j + 1].cantidadPlaneada ? recibaSerialesSOANP[j + 1].cantidadPlaneada : 0);
                    sumCandidadR = parseFloat(recibaSerialesSOANP[j + 1].cantidadRecibida ? recibaSerialesSOANP[j + 1].cantidadRecibida : 0);
                    piezasCarga = parseFloat(recibaSerialesSOANP[j + 1].piezasenCarga ? recibaSerialesSOANP[j + 1].piezasenCarga : 0);
                    piezasPintadas = parseInt(recibaSerialesSOANP[j + 1].piezasPintadas ? recibaSerialesSOANP[j + 1].piezasPintadas : 0);
                    piezasRecuperacion = parseFloat(recibaSerialesSOANP[j + 1].piezasTRecuperacion ? recibaSerialesSOANP[j + 1].piezasTRecuperacion : 0);
                    piezasInspeccionadas = parseFloat((recibaSerialesSOANP[j + 1].piezasInspeccion ? recibaSerialesSOANP[j + 1].piezasInspeccion : 0) +
                        (recibaSerialesSOANP[j + 1].piezasIRecuperacion ? recibaSerialesSOANP[j + 1].piezasIRecuperacion : 0));
                    piezasAEmbarcar = parseFloat(recibaSerialesSOANP[j + 1].piezasAEmbarcar ? recibaSerialesSOANP[j + 1].piezasAEmbarcar : 0);
                    piezasAEmbarcadas = parseFloat(recibaSerialesSOANP[j + 1].piezasEmbarcadas ? recibaSerialesSOANP[j + 1].piezasEmbarcadas : 0);
                    piezasenAlmacen = parseFloat(recibaSerialesSOANP[j + 1].piezasenAlmacen ? recibaSerialesSOANP[j + 1].piezasenAlmacen : 0);

                }
            } else {
                recibaSerialesANP.push({
                    ...recibaseriales, cantidadRecibida: sumCandidadR, piezasenCarga: piezasCarga,
                    piezasPintadas: piezasPintadas, cantidadPlaneada: cantidadPlaneada, piezasTRecuperacion: piezasRecuperacion,
                    piezasInspeccion: piezasInspeccionadas, piezasAEmbarcar: piezasAEmbarcar, piezasEmbarcadas: piezasAEmbarcadas,
                    piezasenAlmacen: piezasenAlmacen
                });
                //Array para imprimir
                recibaSerialesIMP.push({
                    Cliente: recibaseriales.cliente, ["Número de parte"]: recibaseriales.numerodeParte, Descripción: recibaseriales.descripcion,
                    ["Cantidad recibida"]: sumCandidadR, ["Piezas cargadas"]: piezasCarga ? piezasCarga : 0, ["Piezas pintadas"]: piezasPintadas ? piezasPintadas : 0,
                    ["Piezas en recuperación"]: piezasRecuperacion ? piezasRecuperacion : 0,
                    ["Piezas inspeccionadas"]: piezasInspeccionadas, ["Piezas a embarcar"]: piezasAEmbarcar ? piezasAEmbarcar : 0, ["Piezas embarcadas"]: piezasAEmbarcadas ? piezasAEmbarcadas : 0,
                    ["Piezas en almacen"]: piezasenAlmacen ? piezasenAlmacen : 0
                });
            }

            return recibaseriales;
        }));

        recibasinfiltro = recibaSerialesANP;

        setRecibaSeriales(recibasinfiltro);
        setRecibaIMP(recibaSerialesIMP);
    }
    //Obtiene los datos guardados de los planes de producción
    async function fetchReciba(fechainicial, fechafinal) {
        //Filtro por planeación activa        
        setCargando(true);
        let filter = {
            and: [{
                activo: {
                    eq: true
                }
            },
            {
                fechaDeReciba: {
                    ge: fechainicial
                }
            },
            {
                fechaDeReciba: {
                    le: fechafinal
                }
            }]
        }
        const apiData = await GetRecibaSeriales(filter);
        const pProduccionFromAPI = apiData.sort((a, b) =>
            a.numero < b.numero ? 1 : a.numero > b.numero ? -1 : 0);
        setRecibaSinFiltro(pProduccionFromAPI);
        if (pProduccionFromAPI.length) {
            busquedaReciba(pProduccionFromAPI);
        }
        setCargando(false);

    }

    //Revisa cambios en la fecha de búsqueda
    function onChangesRFecha(e) {
        e.persist()
        var fechafin = rfechafin;
        var fechaini = rfechaini;
        if (e.target.name === "fechaIni") {
            setRfechaini(e.target.value);
            fechaini = e.target.value;
        }
        else {
            setRfechafin(e.target.value);
            fechafin = e.target.value;
        }
        fetchReciba(fechaini, fechafin);

    }
    return (
        <>
            {pRProducciones == true && (
                <>
                    <div className="conteiner2">
                        <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                            {mensajeAlert}
                        </Alert>
                        {cargando === true && (
                            <Row>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                    <img width="150px" src="assets/img/preloader.gif" />
                                </div>
                            </Row>
                        )}
                        <Fragment>
                            <div>

                                <Row>
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop10px" >
                                        {recibaSeriales.length > 0 && (<h5 className=" floatleft">Material recibido del {Moment(rfechaini).format("DD/MM/YYYY")} al  {Moment(rfechafin).format("DD/MM/YYYY")}</h5>)}
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 margintop20px " >
                                        <div className='floatrightleft marginrightmobil3p'>
                                            <button className="cbutton btn-dark  ml-1" title="Recargar página" onClick={() => { fetchReciba(rfechaini, rfechafin); }}><IoIcons.IoMdRefresh /> Recargar </button>
                                            <button className="cbutton btn-info  ml-1 " title="Imprimir" hidden={recibaSeriales.length ? false : true} onClick={handlePrint}> Imprimir</button>
                                            <button className="cbutton btn-primary  ml-1 " title="Descargar" hidden={recibaSeriales.length ? false : true}>
                                                <CSVLink className='linkfont' data={recibaIMP} filename={"Reporte de producción del " + Moment(rfechaini).format("DD/MM/YYYY") + " al " + Moment(rfechafin).format("DD/MM/YYYY")}>Descargar</CSVLink>
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <div className=" form-group row col-lg-12 col-md-12 col-sm-12 col-xs-12  floatrightcenter ">
                                            <div className=" form-group row col-lg-6 col-md-6 col-sm-12 col-xs-12   margintop10px mr-1 ">
                                                <InputGroup>
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>Del:</InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input name="fechaIni" type="date" value={Moment(rfechaini).format("YYYY-MM-DD")} onChange={onChangesRFecha} />
                                                </InputGroup>
                                            </div>
                                            <div className=" form-group row col-lg-6 col-md-6 col-sm-12 col-xs-12   margintop10px    ">
                                                <InputGroup className=" ">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>Al:</InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input name="fechaFin" type="date" value={Moment(rfechafin).format("YYYY-MM-DD")} onChange={onChangesRFecha} />
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </div>
                                </Row>
                                <div >
                                    <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                                        <Table className=" mb-2 scroll " >
                                            <Thead className="thead-secondary">
                                                <Tr>
                                                    <Th>Número</Th>
                                                    <Th className="minwidth200px">Cliente</Th>
                                                    <Th className="minwidth200px">Número de parte</Th>
                                                    <Th className="minwidth200px">Descripción</Th>
                                                    <Th>Cantidad recibida</Th>
                                                    <Th className="minwidth60px">Cantidad Planeada</Th>
                                                    <Th className="minwidth60px">Piezas Pintadas</Th>
                                                    <Th className="minwidth60px">En Recuperacion</Th>
                                                    {/*<Th className="minwidth60px">Piezas Inspeccionadas</Th>
                                                    <Th className="minwidth60px">Piezas a Embarcar</Th>*/}
                                                    <Th className="minwidth60px">Piezas Embarcadas</Th>
                                                    <Th className="minwidth60px">Piezas en Almacen</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {recibaSeriales.map((reciba, i) => (
                                                    <Tr className={(i % 2) !== 0 ? "table-active" : ""} >
                                                        <Td>{i + 1}</Td>
                                                        <Td>{reciba.cliente}</Td>
                                                        <Td>{reciba.numerodeParte}</Td>
                                                        <Td >{reciba.descripcion}</Td>
                                                        <Td className={reciba.descripcion ? "" : "margintopmobil20px"}>{reciba.cantidadRecibida}</Td>
                                                        <Td >{reciba.cantidadPlaneada ? reciba.cantidadPlaneada : 0}</Td>
                                                        <Td >{reciba.piezasPintadas ? reciba.piezasPintadas : 0}</Td>
                                                        <Td >{reciba.piezasTRecuperacion ? reciba.piezasTRecuperacion : 0}</Td>
                                                        {/*<Td >{reciba.piezasInspeccion ? reciba.piezasInspeccion : 0}</Td>
                                                        <Td >{reciba.piezasAEmbarcar ? reciba.piezasAEmbarcar : 0}</Td>*/}
                                                        <Td >{reciba.piezasEmbarcadas ? reciba.piezasEmbarcadas : 0}</Td>
                                                        <Td >{reciba.piezasenAlmacen ? reciba.piezasenAlmacen : 0}</Td>
                                                    </Tr>

                                                ))}
                                            </Tbody>
                                        </Table>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1 ">
                                        <h5 className="floatcenter mb-4">{sumProduccionp + "   " + sumICiclos}</h5>
                                    </div>
                                </div>
                                <div className='displaynone'>
                                    <div ref={componentRef}>
                                        <div  >
                                            <img className="floatleft ml-3 mb-4" src="assets/img/Logo/logost.png " />

                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 textaligmentcenter" >
                                                {recibaSeriales.length > 0 && (<h5 className=" ">Reporte de producción del {Moment(rfechaini).format("DD/MM/YYYY")} al  {Moment(rfechafin).format("DD/MM/YYYY")}</h5>)}
                                            </div>
                                        </div>
                                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                            <Table className=" mb-2  " >
                                                <Thead className="thead-secondary">
                                                    <Tr>
                                                        <Th>Número</Th>
                                                        <Th className="minwidth200px">Cliente</Th>
                                                        <Th className="minwidth200px">Número de parte</Th>
                                                        <Th className="minwidth200px">Descripción</Th>
                                                        <Th>Cantidad recibida</Th>
                                                        <Th className="minwidth60px">Cantidad Planeada</Th>
                                                        <Th className="minwidth60px">Piezas Pintadas</Th>
                                                        <Th className="minwidth60px">En Recuperacion</Th>
                                                        {/*<Th className="minwidth60px">Piezas Inspeccionadas</Th>
                                                    <Th className="minwidth60px">Piezas a Embarcar</Th>*/}
                                                        <Th className="minwidth60px">Piezas Embarcadas</Th>
                                                        <Th className="minwidth60px">Piezas en Almacen</Th>
                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    {recibaSeriales.map((recibaSerial, i) => (
                                                        <Tr className={(i % 2) !== 0 ? "table-active" : ""} >
                                                            <Td>{i + 1}</Td>
                                                            <Td>{recibaSerial.cliente}</Td>
                                                            <Td>{recibaSerial.numerodeParte}</Td>
                                                            <Td >{recibaSerial.descripcion}</Td>
                                                            <Td className={recibaSerial.descripcion ? "" : "margintopmobil20px"}>{recibaSerial.cantidadRecibida}</Td>
                                                            <Td >{recibaSerial.cantidadPlaneada ? recibaSerial.cantidadPlaneada : 0}</Td>
                                                            <Td >{recibaSerial.piezasPintadas ? recibaSerial.piezasPintadas : 0}</Td>
                                                            <Td >{recibaSerial.piezasTRecuperacion ? recibaSerial.piezasTRecuperacion : 0}</Td>
                                                            {/*<Td >{recibaSerial.piezasInspeccion ? recibaSerial.piezasInspeccion : 0}</Td>
                                                        <Td >{recibaSerial.piezasAEmbarcar ? recibaSerial.piezasAEmbarcar : 0}</Td>*/}
                                                            <Td >{recibaSerial.piezasEmbarcadas ? recibaSerial.piezasEmbarcadas : 0}</Td>
                                                            <Td >{recibaSerial.piezasenAlmacen ? recibaSerial.piezasenAlmacen : 0}</Td>
                                                        </Tr>

                                                    ))}
                                                </Tbody>
                                            </Table>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1 ">
                                            <h5 className="floatcenter mb-4">{sumProduccionp + "   " + sumICiclos}</h5>
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(pProduccionSinFiltro)}</div>*/}
                                {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(planeacionSinFiltro)}</div>*/}
                            </div>
                        </Fragment>
                    </div>
                </>
            )
            }
        </>
    )
};



export default RPProduccion;
